// NOTE! For the first iteration, we are simply copying the implementation of Assignees
// It will soon be overhauled in Issue https://gitlab.com/gitlab-org/gitlab/-/issues/233736
import { GlTooltipDirective, GlLink } from '@gitlab/ui';
import { TYPE_ISSUE, TYPE_MERGE_REQUEST } from '~/issues/constants';
import { getIdFromGraphQLId } from '~/graphql_shared/utils';
import ReviewerAvatar from './reviewer_avatar.vue';
export default {
    name: 'ReviewerAvatarLink',
    components: {
        ReviewerAvatar,
        GlLink
    },
    directives: {
        GlTooltip: GlTooltipDirective
    },
    props: {
        user: {
            type: Object,
            required: true
        },
        issuableType: {
            type: String,
            default: TYPE_ISSUE,
            required: false
        }
    },
    computed: {
        cannotMerge () {
            return this.issuableType === TYPE_MERGE_REQUEST && !this.user.mergeRequestInteraction?.canMerge;
        },
        reviewerId () {
            return getIdFromGraphQLId(this.user.id);
        },
        reviewerUrl () {
            return this.user.webUrl;
        }
    }
};
